import { FIELD_TYPES_BY_CODE } from "../../field_types";
import { forEach } from "lodash";

export default function (field) {
  return function (item) {
    if (!field || !item) {
      return null;
    }

    const val = item[field.code];

    if (!val || (val && val.length === 0)) {
      return null; // No Rows to check
    }

    var results = {};
    var hasErrors = false;
    forEach(field.fields, function (f) {
      forEach(val, function (row) {
        const FieldType = FIELD_TYPES_BY_CODE[f.field_type];

        if (FieldType) {
          const validator = FieldType.validator(f);

          var result = validator(row);
          if (result != null) {
            results[f.code] = result;
            hasErrors = true; // we have at least 1 error in the Section
          }
        }
      });
    });

    if (hasErrors) {
      return results;
    }
    return null;
  };
}
